import React from 'react';
import { List, Datagrid, Filter, BooleanField, ReferenceField, TextField, TextInput } from 'react-admin';

const StudentsByUnitsFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const StudentsByUnitsList = props => (
  <List filters={<StudentsByUnitsFilter />} {...props} >
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <BooleanField source="enabled" />
    </Datagrid>
</List>
);

export default StudentsByUnitsList